import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Components/Navbar";
import {
  Box,
  Heading,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Button,
  Td,
  HStack,
  Text,
} from "@chakra-ui/react";
import { UserContext } from "../../contexts/User";

const HomeAdmin = () => {
  const navigate = useNavigate();
  const { listUsersApi } = useContext(UserContext);
  const [users, setUsers] = useState({ role_1: [], role_2: [], role_3: [] });
  // Mantemos a estrutura original para disparar a busca na API (globalmente)
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleSelectUser = (user, id) => {
    localStorage.setItem("userInfoID", id);
    navigate(`/user/${user}`);
  };

  const getUsers = async (pageNumber = 1) => {
    try {
      const usersData = await listUsersApi(pageNumber);
      // A API retorna os dados dentro de data[0] com as chaves role_1, role_2, role_3
      setUsers(usersData.data[0] || {});
      // Como a paginação global não é útil (cada role tem a sua),
      // o totalPages global é mantido apenas para disparar a requisição.
      setTotalPages(usersData.data.total_pages || 1);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsers(page);
  }, [page]);

  return (
    <>
      <Navbar />
      <Box
        p={8}
        ml={{ base: 0, md: 60 }}
        bgColor={"#f0f8ff"}
        minH={"100vh"}
        mt={"-35px"}
      >
        <Stack spacing={8}>
          {Object.entries(users).map(
            ([role, data]) =>
              data?.data?.length > 0 && (
                <Box key={role}>
                  <Heading size="md" mb={4}>
                    {role === "role_1"
                      ? "Lista de Admins"
                      : role === "role_2"
                      ? "Lista de Professores"
                      : "Lista de Alunos"}
                  </Heading>
                  <Table variant="striped">
                    <Thead>
                      <Tr>
                        <Th>ID</Th>
                        <Th>Nome</Th>
                        <Th>E-mail</Th>
                        {role === "role_2" && <Th>Qtde de Questões</Th>}
                        <Th>Ações</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {data.data.map((user) => (
                        <Tr key={user.id}>
                          <Td>{user.id}</Td>
                          <Td>{user.name}</Td>
                          <Td>{user.email}</Td>
                          {role === "role_2" && <Td>{user.questions_count}</Td>}
                          <Td>
                            <Button
                              colorScheme="teal"
                              size="sm"
                              onClick={() =>
                                handleSelectUser(user.name, user.id)
                              }
                            >
                              Ver perfil
                            </Button>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                  <HStack mt={4} justifyContent="center">
                    {role === "role_3" ? (
                      <>
                        <Button
                          onClick={() => setPage(page - 1)}
                          isDisabled={page === 1}
                        >
                          Anterior
                        </Button>
                        <Text>
                          Página {page} de {data.last_page}
                        </Text>
                        <Button
                          onClick={() => setPage(page + 1)}
                          isDisabled={page === data.last_page}
                        >
                          Próximo
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button isDisabled>Anterior</Button>
                        <Text>Página 1 de 1</Text>
                        <Button isDisabled>Próximo</Button>
                      </>
                    )}
                  </HStack>
                </Box>
              )
          )}
        </Stack>
      </Box>
    </>
  );
};

export default HomeAdmin;
